var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"admin-footer":""}},[_c('div',[_c('div',{staticClass:"wrapper"},[_c('p',[_vm._v(_vm._s(_vm.asset('address'))+" "),_c('span',{staticClass:"mh-10"},[_vm._v("|")]),_vm._v(" "+_vm._s(_vm.asset('companyNo')))]),_vm._v("\n      COPYRIGHT (C) 2018 "+_vm._s(_vm.asset('name'))+" KS 인증시스템. All RIGHT RESERVED\n    ")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9b3276","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/common/AppFooter.vue
// module id = 5le/
// module chunks = 241